import React, { useState, useEffect } from 'react';
import './BuscadorViajes.css'; 

export default function BuscadorViajes({ onBuscar, mapaZonas }) {
  // 1. OBTENER ZONAS VALIDAS (Que sean Arrays reales)
  const zonasDisponibles = Object.keys(mapaZonas).filter(key => Array.isArray(mapaZonas[key]));

  // Estados
  const [tipoViaje, setTipoViaje] = useState('sencillo');
  const [zonaOrigen, setZonaOrigen] = useState('');
  const [terminalOrigen, setTerminalOrigen] = useState('');
  const [zonaDestino, setZonaDestino] = useState('');
  const [terminalDestino, setTerminalDestino] = useState('');
  const [fechaIda, setFechaIda] = useState('');
  const [fechaRegreso, setFechaRegreso] = useState('');

  // ✅ AUTO-SELECCIÓN: Si no hay nada seleccionado, elegir el primero automáticamente
  useEffect(() => {
    if (zonasDisponibles.length > 0) {
      if (!zonaOrigen) {
        const primeraZona = zonasDisponibles[0];
        setZonaOrigen(primeraZona);
        setTerminalOrigen(mapaZonas[primeraZona]?.[0] || '');
        
        const segundaZona = zonasDisponibles[1] || zonasDisponibles[0];
        setZonaDestino(segundaZona);
        setTerminalDestino(mapaZonas[segundaZona]?.[0] || '');
      }
    }
  }, [zonasDisponibles, mapaZonas, zonaOrigen]);

  // Lógica: Si cambio la ZONA Origen, actualizo su terminal
  useEffect(() => {
    if (zonaOrigen && mapaZonas[zonaOrigen] && !mapaZonas[zonaOrigen].includes(terminalOrigen)) {
      setTerminalOrigen(mapaZonas[zonaOrigen][0] || '');
    }
  }, [zonaOrigen, mapaZonas, terminalOrigen]);

  // Lógica: Si cambio la ZONA Destino, actualizo su terminal
  useEffect(() => {
    if (zonaDestino && mapaZonas[zonaDestino] && !mapaZonas[zonaDestino].includes(terminalDestino)) {
      setTerminalDestino(mapaZonas[zonaDestino][0] || '');
    }
  }, [zonaDestino, mapaZonas, terminalDestino]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!terminalOrigen || !terminalDestino) return alert("Espera a que carguen las rutas...");
    if (!fechaIda) return alert("Selecciona fecha de salida");
    
    // 🔒 CANDADO DE SEGURIDAD: Evita búsquedas nulas
    if (terminalOrigen === terminalDestino) {
      return alert("El origen y el destino no pueden ser el mismo lugar.");
    }

    if (tipoViaje === 'redondo' && !fechaRegreso) return alert("Selecciona fecha de regreso");

    onBuscar({ 
      origen: terminalOrigen, 
      destino: terminalDestino, 
      fecha: fechaIda, 
      fechaRegreso: tipoViaje === 'redondo' ? fechaRegreso : null,
      tipoViaje,
      cantidadPasajeros: 1
    });
  };

  if (zonasDisponibles.length === 0) {
    return (
      <div className="buscador-container text-center text-white p-6">
        <h2 className="text-xl font-bold">⚠️ No se encontraron rutas</h2>
        <p className="text-sm mt-2">Revisa la colección 'configuraciones/terminales' en Firebase.</p>
        <p className="text-xs mt-1 opacity-70">Esperando Arrays...</p>
      </div>
    );
  }

  return (
    <div className="buscador-container">
      <h2 className="buscador-titulo">🔍 Reserva tu viaje</h2>
      
      <form onSubmit={handleSubmit} className="buscador-form">
        
        {/* TIPO DE VIAJE */}
        <div className="tipo-viaje-group">
           <label className={`radio-option ${tipoViaje === 'sencillo' ? 'active' : ''}`}>
            <input type="radio" checked={tipoViaje === 'sencillo'} onChange={() => setTipoViaje('sencillo')} />
            Viaje Sencillo
          </label>
          <label className={`radio-option ${tipoViaje === 'redondo' ? 'active' : ''}`}>
            <input type="radio" checked={tipoViaje === 'redondo'} onChange={() => setTipoViaje('redondo')} />
            Viaje Redondo
          </label>
        </div>

        <div className={`inputs-row ${tipoViaje === 'redondo' ? 'modo-redondo' : ''}`}>
          
          {/* SELECCIÓN ORIGEN */}
          <div className="input-group">
            <label>Origen</label>
            <select 
              value={terminalOrigen} 
              onChange={(e) => {
                 const term = e.target.value;
                 setTerminalOrigen(term);
                 const zonaPadre = zonasDisponibles.find(z => mapaZonas[z].includes(term));
                 if(zonaPadre) {
                   setZonaOrigen(zonaPadre);
                   
                   // 🛠️ LA MAGIA: Si el nuevo origen choca con el destino, reseteamos el destino
                   if (zonaPadre === zonaDestino) {
                     const nuevaZonaDestino = zonasDisponibles.find(z => z !== zonaPadre);
                     if (nuevaZonaDestino) {
                       setZonaDestino(nuevaZonaDestino);
                       setTerminalDestino(mapaZonas[nuevaZonaDestino][0]);
                     }
                   }
                 }
              }}
            >
              {zonasDisponibles.map(zona => (
                <optgroup key={zona} label={zona.toUpperCase()}>
                  {mapaZonas[zona].map(term => (
                    <option key={term} value={term}>{term}</option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>

          {/* SELECCIÓN DESTINO */}
          <div className="input-group">
            <label>Destino</label>
            <select 
              value={terminalDestino} 
              onChange={(e) => {
                 const term = e.target.value;
                 setTerminalDestino(term);
                 const zonaPadre = zonasDisponibles.find(z => mapaZonas[z].includes(term));
                 if(zonaPadre) setZonaDestino(zonaPadre);
              }}
            >
              {zonasDisponibles
                .filter(z => z !== zonaOrigen) // Evita seleccionar la misma zona
                .map(zona => (
                  <optgroup key={zona} label={zona.toUpperCase()}>
                    {mapaZonas[zona].map(term => (
                      <option key={term} value={term}>{term}</option>
                    ))}
                  </optgroup>
              ))}
            </select>
          </div>

          {/* FECHA IDA */}
          <div className="input-group">
            <label>Fecha Salida</label>
            <input type="date" value={fechaIda} onChange={(e) => setFechaIda(e.target.value)} min={new Date().toLocaleDateString('en-CA')} required />
          </div>

          {/* FECHA REGRESO */}
          {tipoViaje === 'redondo' && (
            <div className="input-group animate-in fade-in">
              <label>Fecha Regreso</label>
              <input type="date" value={fechaRegreso} onChange={(e) => setFechaRegreso(e.target.value)} min={fechaIda || new Date().toLocaleDateString('en-CA')} required />
            </div>
          )}
        </div>

        <button type="submit" className="btn-buscar">Buscar Viajes</button>
      </form>
    </div>
  );
}